const SESSION_QUERY_KEY = 'session';
const TOKEN_KEY = 'pushio_token';

export function getSessionNamespace(): string {
  try {
    const locationSearch = (globalThis as { location?: { search?: string } }).location?.search ?? '';
    const value = new URLSearchParams(locationSearch).get(SESSION_QUERY_KEY)?.trim();
    return value ? value.replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 32) : 'default';
  } catch {
    return 'default';
  }
}

export function getScopedStorageKey(baseKey: string): string {
  const namespace = getSessionNamespace();
  return namespace === 'default' ? baseKey : `${baseKey}:${namespace}`;
}

export function readScopedToken(): string | null {
  return readScopedStorageValue(TOKEN_KEY);
}

export function writeScopedToken(token: string): void {
  writeScopedStorageValue(TOKEN_KEY, token);
}

export function readScopedStorageValue(baseKey: string): string | null {
  try {
    const storage = (globalThis as { localStorage?: { getItem(key: string): string | null } }).localStorage;
    return storage?.getItem(getScopedStorageKey(baseKey)) ?? null;
  } catch {
    return null;
  }
}

export function writeScopedStorageValue(baseKey: string, value: string): void {
  try {
    const storage = (globalThis as { localStorage?: { setItem(key: string, nextValue: string): void } }).localStorage;
    storage?.setItem(getScopedStorageKey(baseKey), value);
  } catch {
    // Ignore storage failures in restricted contexts.
  }
}
